module.exports = __webpack_public_path__ + "img/badermanr.226bf8fb.jpg";